import { JsonFailResponse } from '../json-response.interface';

export class ExternalValidationException extends Error {
    private readonly fields: Record<string, string[]>;

    private constructor(fields: Record<string, string[]>) {
        const fieldsString = JSON.stringify(fields);
        const message = `External validation has failed on the following fields: ${fieldsString}`;
        super(message);

        this.fields = fields;
    }

    public static createFromJsonFailResponse(response: JsonFailResponse): ExternalValidationException {
        return new ExternalValidationException(response.data);
    }

    public getFailedFields(): Record<string, string[]> {
        return this.fields;
    }
}
